// assume "content missing" is a page visit
document.addEventListener('turbo:frame-missing', (e) => {
  e.preventDefault()

  const targetLocation = e.detail.response.url
  e.detail.visit(targetLocation)
})

console.log('app is ready')